import { render, staticRenderFns } from "./locomotive-control-review-details.vue?vue&type=template&id=23678de7&scoped=true"
import script from "./locomotive-control-review-details.vue?vue&type=script&lang=js"
export * from "./locomotive-control-review-details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23678de7",
  null
  
)

export default component.exports